import { AUTOMATIC_ID } from '../../constants';
export var isNotAutomaticId = function isNotAutomaticId(value) {
  return value !== AUTOMATIC_ID;
};